var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVsIcon = function SvgVsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vs-icon_svg__filter0_d_9880_92295)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.001,
    cy: 36.435,
    r: 18.582,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 32.703l-3.584 9.772h-2.38l-3.584-9.772h2.1l2.688 7.77 2.674-7.77h2.086zM47.55 42.573c-.68 0-1.297-.117-1.847-.35a3.03 3.03 0 01-1.288-1.008c-.318-.439-.48-.957-.49-1.554h2.1c.028.401.168.718.42.952.261.233.616.35 1.064.35.457 0 .816-.108 1.078-.322a1.09 1.09 0 00.392-.868.995.995 0 00-.266-.714 1.782 1.782 0 00-.672-.434 9.204 9.204 0 00-1.092-.364 13.056 13.056 0 01-1.554-.546 2.88 2.88 0 01-1.022-.826c-.28-.374-.42-.868-.42-1.484 0-.579.144-1.083.434-1.512.29-.43.695-.756 1.218-.98.522-.234 1.12-.35 1.792-.35 1.008 0 1.824.247 2.45.742.634.485.984 1.166 1.05 2.044H48.74a1.09 1.09 0 00-.434-.826c-.262-.224-.612-.336-1.05-.336-.383 0-.69.098-.924.294-.224.196-.336.48-.336.854 0 .261.084.48.252.658.177.168.392.308.644.42.261.102.625.224 1.092.364.634.186 1.152.373 1.554.56a2.79 2.79 0 011.036.84c.29.373.434.863.434 1.47 0 .522-.136 1.008-.406 1.456-.27.448-.668.807-1.19 1.078-.523.261-1.144.392-1.862.392z",
    fill: "#584568"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F05",
    strokeLinecap: "round",
    d: "M8.5 35.935h11M65.791 35.935h11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vs-icon_svg__filter0_d_9880_92295",
    x: 0.418,
    y: 0.853,
    width: 85.165,
    height: 85.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.196078 0 0 0 0 0.258824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9880_92295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9880_92295",
    result: "shape"
  })))));
};
export default SvgVsIcon;